import React, { useEffect, useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { api } from 'core/api/ConnectionManager'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import {
    SUBJECTS_CATALOG_CONFIG,
    SUBJECTS_CATALOG_TYPE,
    SubjectsAdditionalData,
    SubjectsCatalogOption,
    SubjectsSelectedItems,
} from './InstancesCatalogSubjects-types'

const InstancesCatalogSubjectsComponent = () => {
    const [selectedItems, setSelectedItems] = useState<SubjectsSelectedItems>([])
    const [additionalData, setAdditionalData] = useState<SubjectsAdditionalData>({
        grades: [],
        courses: [],
    })

    useEffect(() => {
        api.send('getGrades', {}).then((res) => {
            const { data } = res as { data: SubjectsCatalogOption[] }
            setAdditionalData((prev) => ({ ...prev, grades: data }))
        })
        api.send('getCourses', {}).then((res) => {
            const { data } = res as { data: SubjectsCatalogOption[] }
            setAdditionalData((prev) => ({ ...prev, courses: data }))
        })
    }, [])

    return (
        <Content title={SUBJECTS_CATALOG_TYPE}>
            <Catalog
                type={SUBJECTS_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                additionalData={additionalData}
                fixedHeader={SUBJECTS_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={SUBJECTS_CATALOG_CONFIG.isExistRightToolbar}
                treeView={SUBJECTS_CATALOG_CONFIG.treeView}
            />
        </Content>
    )
}

export const InstancesCatalogSubjects = checkAvailableModule('instancesCatalog/subjects')
    ? InstancesCatalogSubjectsComponent
    : null
